<script setup lang="ts">
    const props = defineProps(['show', 'border']);
    const emit = defineEmits(['close'])

    function close() {
        emit('close')
    }
</script>

<template>
    <teleport to="body">
        <div v-if="props.show" class="fixed inset-0 bg-black/50 flex justify-center items-center w-full h-full z-50" @click.self="close">
            <div class="relative flex bg-white rounded-lg
                w-[95vw] max-w-[95vw] sm:w-[80vw] sm:max-w-[80vw] lg:min-w-[600px] lg:max-w-[800px]" :class="border ? 'border-2 border-secondary' : ''">
                <slot />
                <button class="absolute top-0 right-0 w-7 h-7 text-xl font-bold" @click="close">x</button>
            </div>
        </div>
    </teleport>
</template>
